module.exports = {
      id: "right-arrow-usage",
      viewBox: "0 0 15 16",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#right-arrow-usage",
      toString: function () {
        return this.url;
      }
    }